import React, {useState, useEffect} from "react";
import {Form, Row, Col, Input, Button, Collapse, Card, Table} from 'antd';
import jsonfile from './localexpenses.json'
import {Link, useHistory, useRouteMatch} from "react-router-dom";
import {CisUI} from '../../../../util/CISUI';
import AdvancedSearch from '../../../../util/AdvancedSearch';
import ActionButton from '../../../../util/actionbutton';
import SmartDataTable from 'react-smart-data-table';
import 'react-smart-data-table/dist/react-smart-data-table.css';
import IntlMessages from "util/IntlMessages";
import Config from "../../../../util/config";
import SelectData from "../../../../util/selectdata";
import axios from '../../../../util/Api'
import Pdf from "react-to-pdf";

const Search = Input.Search;
const Panel = Collapse.Panel;

const RegionMonthlyReport = () => {
    const value = 0;
    const ref = React.createRef();
    const formRef = React.createRef();
    const [state, setState] = useState({
        reqURL: Config.apiserver + jsonfile.urls.monthly,
        filtervalue: '',
        reportTitle: '',
        reportData: [],
        totalContribution: 0,
        month: "",
        region: "",
        district: "",
        districts: [],
        districtData: [],
        contribution: [],
        expensesOffice: [],
        expensesMission: [],
        totalExpenses: 0,
        netTitheAfterExpense: 0,
        rdf: 0,
        retainRDF: 0,
        aidf: 0,
        NetTitheToNation: 0,
        missionOffering: 0,
        MinistryIncome: 0,
        Mckeowns: 0,
        InternalMissions: 0,
        NationalPrayer: 0,
        PENSOS: 0,
        netCashToNation: 0,
    });

    const [report, setReport] = useState({});

    const history = useHistory();


    const [expand, setExpand] = useState(false);
    const [form] = Form.useForm();

    const onFinish = values => {
        console.log('Received values of form: ', values);
        let wkd = "";
        let wk = "";
        let dt = "";
        const qs = Object.keys(values).map(key => {
                if (key === 'date') {
                    wk = formRef.current.getFieldValue('date');
                    const dt = CisUI().ParseDateFormat(values[key]);
                    return `${key}=${dt}`
                } else if (key === 'month') {
                    wk = formRef.current.getFieldValue('month');
                    // console.log("Selected Week : "+ wk);
                    const mnts = CisUI().ParseDateFormatFromMonth(wk);
                    //console.log(mnts);
                    wkd = mnts;
                    return `${key}=${mnts}`
                } else {
                    return `${key}=${values[key]}`
                }
            }
        ).join('&');

        const qsup = qs.replaceAll("undefined", "");
        //reqURL = reqURL+"/?"+qsup;
        history.push("?" + qsup);
        const newURL = Config.apiserver + jsonfile.urls.monthly + "?" + qsup;
        console.log("NEURL :" + newURL);
        console.log("Month : " + wkd);
        const WKR = CisUI().ParseDateFormat(wk);
        //const reportTitle = "Between " + CisUI().DateFormat(WKR[0]) + " and " + CisUI().DateFormat(WKR[1]);
        const reportTitle = "Monthly Report For the month of "+CisUI().getMonthTitle(wkd);

        const url = Config.apiserver + jsonfile.urls.monthly;
        //const data = SelectData(url);

        // setState({
        //     reqURL: newURL,
        //     reportTitle: reportTitle
        // });
        document.getElementById("loader").style.display = "block";
        axios.get(newURL)
            .then((res) => {
                console.log(res.data);
                document.getElementById("loader").style.display = "none";
                if (res.data.status === 1) {
                    //console.log("Response : "+ res.data);
                    const data = res.data.data;
                    setState({
                        contribution: data.contribution,
                        totalContribution: data.totalContribution,
                        districts: data.districts,
                        districtData: data.districtData,
                        district: data.district,
                        region: data.region,
                        reportTitle: reportTitle,
                        month: CisUI().getMonthTitle(wkd),
                        expenses: data.expenses,
                        expensesOffice: data.expensesOffice,
                        expensesMission: data.expensesMission,
                        totalExpensesOffice: data.totalExpensesOffice,
                        totalExpensesMission: data.totalExpensesMission,
                        totalExpenses: data.totalExpenses,
                        netTitheAfterExpense: data.netTitheAfterExpense,
                        rdf: data.rdf,
                        retainRDF: data.retainRDF,
                        aidf: data.aidf,
                        NetTitheToNation: data.NetTitheToNation,
                        missionOffering: data.missionOffering,
                        MinistryIncome: data.MinistryIncome,
                        Mckeowns: data.Mckeowns,
                        InternalMissions: data.InternalMissions,
                        NationalPrayer: data.NationalPrayer,
                        PENSOS: data.PENSOS,
                        netCashToNation: data.netCashToNation,
                    })
                }
            })
            .catch((error) => {
                console.log(error);
                document.getElementById("loader").style.display = "none";
            });
    };

    const handleOnFilter = ({target: {name, value}}) => {
        //filterValue = value;
        console.log("filteringwith :" + value);
        setState({filtervalue: "test"});
    }

    let searchView = "";
    if (jsonfile.has_search) {
        searchView = <Card className="advance-search-card no-print">
            <Collapse
                accordion
                expandIconPosition="right"
                defaultActiveKey={['1']}>
                <Panel header="Advance Search" key="1">
                    <Form
                        key={5}
                        form={form}
                        ref={formRef}
                        {...CisUI().formItemLayout}
                        name="advanced_search"
                        className="ant-advanced-search-form"
                        onFinish={onFinish}
                    >
                        {AdvancedSearch(jsonfile.input, "", 0, 'month')}
                    </Form>
                </Panel>
            </Collapse>
        </Card>
    }

    const getExtra = (
        <>
            {CisUI().listAction("../" + jsonfile.urls.add)}
        </>
    );


    const ReportData = state.reportData;
    const expenseTypes = SelectData("donation/expensetype?area=6");

    const options = {
        orientation: 'landscape',
        unit: 'in',
        format: [4, 2]
    };

    return (
        <>
            {searchView}
            <Card id="reportview" extra={getExtra}>
                {CisUI().showLoading}
                <div ref={ref}>
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <h3>Region Monthly Report</h3>
                            <h2>{state.reportTitle}</h2>
                        </div>
                        <div className="col-md-6">
                            <strong>Month :</strong> {state.month}
                        </div>
                        <div className="col-md-6 text-right">
                            <table width={400}>
                                <tr>
                                    <th style={{textAlign: 'left'}}>Region</th>
                                    <td>: {state.region}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <h4>District Income & Expneses</h4>
                    <div className="table-responsive">
                    <table className="report2 table table-bordered">
                        <thead>
                        <tr>
                            <th>Title</th>
                            {
                                state.districts.map((items, index) =>
                                    <th style={{textAlign: 'right'}}>{items.name}</th>
                                )
                            }
                            <th style={{textAlign: 'right'}}>Total</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            state.districtData.map((items, index) => {

                                    if (items.type === 'total') {
                                        return <tr>
                                            <td style={{fontWeight: 'bold'}}>{items.title}</td>
                                            {
                                                state.districts.map((items1, index1) =>
                                                    <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'bold'
                                                    }}>{CisUI().getCurrencyFormated1(items.districtData[index1])}</td>
                                                )
                                            }
                                            <td style={{
                                                textAlign: 'right',
                                                fontWeight: 'bold'
                                            }}>{CisUI().getCurrencyFormated1(items.total)}</td>
                                        </tr>
                                    } else if (items.type === 'minusBold') {
                                        return <tr>
                                            <td style={{fontWeight: 'bold'}}>{items.title}</td>
                                            {
                                                state.districts.map((items1, index1) =>
                                                    <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'bold'
                                                    }}>({CisUI().getCurrencyFormated1(items.districtData[index1])})</td>
                                                )
                                            }
                                            <td style={{
                                                textAlign: 'right',
                                                fontWeight: 'bold'
                                            }}>({CisUI().getCurrencyFormated1(items.total)})
                                            </td>
                                        </tr>
                                    } else if (items.type === 'minus') {
                                        return <tr>
                                            <td>{items.title}</td>
                                            {
                                                state.districts.map((items1, index1) =>
                                                    <td style={{textAlign: 'right'}}>({CisUI().getCurrencyFormated1(items.districtData[index1])})</td>
                                                )
                                            }
                                            <td style={{textAlign: 'right'}}>({CisUI().getCurrencyFormated1(items.total)})</td>
                                        </tr>
                                    } else {
                                        return <tr>
                                            <td>{items.title}</td>
                                            {
                                                state.districts.map((items1, index1) =>
                                                    <td style={{textAlign: 'right'}}>{CisUI().getCurrencyFormated1(items.districtData[index1])}</td>
                                                )
                                            }
                                            <td style={{textAlign: 'right'}}>{CisUI().getCurrencyFormated1(items.total)}</td>
                                        </tr>
                                    }

                                }
                            )
                        }
                        </tbody>
                    </table>
                    </div>

                    <h4>Region Income & Expneses</h4>
                    <table className="report table table-bordered">
                        <thead>
                        <tr>
                            <th>Title</th>
                            <th style={{textAlign: 'right'}}>Amount</th>
                            <th style={{textAlign: 'right'}}>Amount</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <th>TOTAL CONTRIBUTION RECEIVED (Gross Tithe & Offering)</th>
                            <th style={{textAlign: 'right'}}></th>
                            <th style={{textAlign: 'right'}}>{CisUI().getCurrencyFormated1(state.totalContribution)}</th>
                        </tr>

                        <tr>
                            <th>ALLOWABLE REGION OFFICE EXPENSES</th>
                            <th style={{textAlign: 'right'}}></th>
                            <th style={{textAlign: 'right'}}></th>
                        </tr>
                        {
                            state.expensesOffice.map((items, index) => {
                                    return <tr>
                                        <td>{items.title}</td>
                                        <td style={{textAlign: 'right'}}>{CisUI().getCurrencyFormated1(items.amount)}</td>
                                        <td style={{textAlign: 'right'}}></td>
                                    </tr>
                                }
                            )
                        }
                        <tr>
                            <th>Total Allowable Region Office Expenses</th>
                            <th style={{textAlign: 'right'}}></th>
                            <th style={{textAlign: 'right'}}>({CisUI().getCurrencyFormated1(state.totalExpensesOffice)})</th>
                        </tr>

                        <tr>
                            <th>ALLOWABLE REGION MISSION HOUSE EXPENSES</th>
                            <th style={{textAlign: 'right'}}></th>
                            <th style={{textAlign: 'right'}}></th>
                        </tr>
                        {
                            state.expensesMission.map((items, index) => {
                                    return <tr>
                                        <td>{items.title}</td>
                                        <td style={{textAlign: 'right'}}>{CisUI().getCurrencyFormated1(items.amount)}</td>
                                        <td style={{textAlign: 'right'}}></td>
                                    </tr>
                                }
                            )
                        }
                        <tr>
                            <th>Total Allowable Region Mission House Expenses</th>
                            <th style={{textAlign: 'right'}}></th>
                            <th style={{textAlign: 'right'}}>({CisUI().getCurrencyFormated1(state.totalExpensesMission)})</th>
                        </tr>
                        <tr>
                            <th>Total Allowable Expenses</th>
                            <th style={{textAlign : 'right'}}></th>
                            <th style={{textAlign : 'right'}}>({CisUI().getCurrencyFormated1(state.totalExpenses)})</th>
                        </tr>
                        <tr>
                            <th colSpan={2} style={{textAlign : 'right'}}>Net Tithe After Region Allowable Expenses</th>
                            <th style={{textAlign : 'right'}}>{CisUI().getCurrencyFormated1(state.netTitheAfterExpense)}</th>
                        </tr>
                        <tr>
                            <th colSpan={2} style={{textAlign : 'right'}}>Less: Region Development Fund (RDF : 10%)</th>
                            <th style={{textAlign : 'right'}}>({CisUI().getCurrencyFormated1(state.rdf)})</th>
                        </tr>
                        <tr>
                            <th colSpan={2} style={{textAlign : 'right'}}></th>
                            <td style={{textAlign : 'right'}}></td>
                        </tr>
                        <tr>
                            <th colSpan={2} style={{textAlign : 'right'}}>Distribution of 10% RDF</th>
                            <td style={{textAlign : 'right'}}></td>
                        </tr>
                        <tr>
                            <td colSpan={2} style={{textAlign : 'right'}}>Retained 70% of RDF</td>
                            <td style={{textAlign : 'left'}}>{CisUI().getCurrencyFormated1(state.retainRDF)}</td>
                        </tr>
                        <tr>
                            <td colSpan={2} style={{textAlign : 'right'}}>Remit 30% of RDF As AIDF</td>
                            <td style={{textAlign : 'left'}}>{CisUI().getCurrencyFormated1(state.aidf)}</td>
                        </tr>
                        <tr>
                            <th colSpan={2} style={{textAlign : 'right'}}></th>
                            <td style={{textAlign : 'right'}}></td>
                        </tr>
                        <tr>
                            <th colSpan={2} style={{textAlign : 'right'}}>Net Tithe to Nation</th>
                            <th style={{textAlign : 'right'}}>{CisUI().getCurrencyFormated1(state.NetTitheToNation)}</th>
                        </tr>
                        <tr>
                            <th colSpan={2} style={{textAlign : 'right'}}>Add : Missions Offering</th>
                            <th style={{textAlign : 'right'}}>{CisUI().getCurrencyFormated1(state.missionOffering)}</th>
                        </tr>
                        <tr>
                            <th colSpan={2} style={{textAlign : 'right'}}><a href="#">Add : Ministry Income</a></th>
                            <th style={{textAlign : 'right'}}>{CisUI().getCurrencyFormated1(state.MinistryIncome)}</th>
                        </tr>
                        <tr>
                            <th colSpan={2} style={{textAlign : 'right'}}>Add : Mckeowns</th>
                            <th style={{textAlign : 'right'}}>{CisUI().getCurrencyFormated1(state.Mckeowns)}</th>
                        </tr>
                        <tr>
                            <th colSpan={2} style={{textAlign : 'right'}}>Add : Internal Missions</th>
                            <th style={{textAlign : 'right'}}>{CisUI().getCurrencyFormated1(state.InternalMissions)}</th>
                        </tr>
                        <tr>
                            <th colSpan={2} style={{textAlign : 'right'}}>Add : National Prayer</th>
                            <th style={{textAlign : 'right'}}>{CisUI().getCurrencyFormated1(state.NationalPrayer)}</th>
                        </tr>
                        <tr>
                            <th colSpan={2} style={{textAlign : 'right'}}>Add : PENSOS</th>
                            <th style={{textAlign : 'right'}}>{CisUI().getCurrencyFormated1(state.PENSOS)}</th>
                        </tr>
                        <tr>
                            <th colSpan={2} style={{textAlign : 'right'}}>NET CASH SENT TO NATION	</th>
                            <th style={{textAlign : 'right'}}>{CisUI().getCurrencyFormated1(state.netCashToNation)}</th>
                        </tr>

                        </tbody>
                    </table>
                </div>

            </Card>
        </>
    );
};

export default RegionMonthlyReport;